<template>
  <Container type="card-full">
    <div slot="header">
      <el-button  @click="saveBrowscol">保存</el-button>
      <el-button  @click="showsql">显示sql</el-button>
      <el-button  @click="close">关闭</el-button>
    </div>
    <el-form :model="docgen" ref="form" label-position="left" label-width="100px">
      <el-form-item label="完整sql" v-if="docgensql">
        <el-input v-model="docgensql" :maxlength="1024" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="过滤条件">
        <el-input v-model="docgen.docgenwhere" :maxlength="1024" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <vggrid ref="xGrid" :list="list" tableheight="500" flexname="docgencolflex"
            :showfooter="false" :showPage="false" :resizable="true"
            :needSelection="true" :needRowNum="false"
            :needBlackRow="false" :needPopMenu="false" :canbeEdit="true"
            @cellClick="cellClick">
    </vggrid>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  export default {
    name: 'docgencolForm',
    data () {
      return {
        list: [],
        docgen: this.$route.params.form,
        form: {},
        docgensql: '',
        loading: true
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getGendoccolList()
      this.getDsfieldList()
    },
    mounted () {
    },
    components: {vggrid},
    methods: {
      async init() {
        this.list = []
        this.docgen = this.$route.params.form
        this.form = {}
        this.docgensql = ''
        this.loading = true
      },
      async showsql() {
        this.docgensql = this.docgen.docgenselect + this.docgen.docgenfrom + ' ' + this.docgen.docgenwhere + this.docgen.docgenorderby
      },
      async getDsfieldList() {
        let data = await request({
          method: 'get',
          url: '/xtgl/ds/getDsfieldListByDsid',
          params: {dsid: this.docgen.docgendsid}
        })
        console.log(data)
        setTimeout(() => {
          this.$refs.xGrid.$refs.xGrid.$options.propsData.columns[5].editRender.options = data
        },300)
      },
      async saveBrowscol () {
        let model = {
          docgencols:this.$refs.xGrid.$refs.xGrid.getSelectRecords(),
          docgenid: this.docgen.docgenid
        }

        await request({
          url: '/kfgl/docgen/saveDocgencol',
          method: "post",
          data: model
        })
        this.$message.success('操作成功')
        await this.getGendoccolList()
      },
      async cellClick (row) {
        this.form = row.row
      },
      async pagechange (fcPage) {
        this.query.currPage = fcPage.currentPage
        this.query.pageSize = fcPage.pageSize
        this.getGendoccolList()
      },
      async getGendoccolList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/docgen/getDocgencolPageList',
          params: {flexid: this.docgen.docgenflexid,docgenid: this.docgen.docgenid}
        })
        console.log(res)
        this.list = res
        this.loading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'docgenIndex'})

      }
    },
    filters: {
    }
  }
</script>

<style lang="scss" scoped>
</style>
